import dynamic from "next/dynamic";
import React, { Suspense } from "react";
import useStore from "../../../../context/useStore";

const Types = dynamic(() => import("./Types"), {
  suspense: true,
});

const Rooms = dynamic(() => import("./Rooms"), {
  suspense: true,
});

interface AdditionalProps {
  data: any;
}

const Additional: React.FC<AdditionalProps> = ({ data }) => {
  const { auth } = useStore();
  return (
    <Suspense fallback={<></>}>
      <div className="py-5">
        <div className="font-normal text-2xl w-full flex flex-col gap-2 pb-2">
          <h4 className="text-lg font-normal">Additional Details</h4>
          <hr />
        </div>
        <Suspense fallback={<></>}>
          <Types data={data} Auth={auth} />
        </Suspense>
        <Suspense fallback={<></>}>
          <Rooms data={data} Auth={auth} />
        </Suspense>
      </div>
    </Suspense>
  );
};

export default Additional;
